export default {
  'Your win': '您的胜利',
  'Select skins that you want to take': '选择您想要的皮肤',
  'By price': '按价格',
  '(Autotrade will receive after 10 minutes)': '(10分钟后收到自动交易)',
  ACCEPT: '确认',
  'SELECT ALL': 'SELECT ALL',
};
